import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import prefrence from "../../assets/images/rsicons/prefrence.png"

//import Lead from "./Lead";
import ClientLink from "./client-link";
import { getClientDetail,  addClientChild, getClientChild, deleteClientChild} from "../../store/clients/actions"
import Switch from "react-switch"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import {  isEmpty, map, size } from "lodash";
import Moment from 'react-moment';
import DeleteModal from "../../components/Common/DeleteModal";
import ClientSidebar from "components/VerticalLayout/ClientSidebar";

import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  Collapse
} from "reactstrap"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios"
import ClientProfileBreadcrumbs from "components/Common/ClientProfileBreadcrumb";
import ClientProfileMenu from "./menu/client-profile-menu";
import LineBreadcrumbs from "components/Common/LineBreadcrumb";
import SafeField from "helpers/SafeField";
class ClientFaimilyProfile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      rows: [],
      rows1: [],
      clientTypes:[],
      titles:[],
      child: '',
      sources:[],
     
      
    }

    this.handleChildSubmit = this.handleChildSubmit.bind(this)
    this.onClickDelete = this.onClickDelete.bind(this);
   
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
    }));
  };
  onClickDelete = (child) => {
    this.setState({ child: child });
    this.setState({ deleteModal: true });
  };
  handleDeleteChild = () => {
    const { onDeleteChild } = this.props;
    const { child } = this.state;
    
    if (child.id !== undefined) {
      onDeleteChild(child);
      this.setState({ deleteModal: false });
    }
  };
  

  handleChildSubmit(value){
    this.props.addClientChild(value, this.props.history);
  }


componentDidMount() {
  const { match: { params }, onGetClientDetail, onGetClientChild } = this.props;
  onGetClientDetail(params.clientId);
  onGetClientChild(params.id)
 

    
}
  render() {
    const { clietDetail, childs, loading, isResponsive } = this.props;
    const child = this.state.child;
    const {  deleteModal } = this.state;
    //
   
    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
         <div className="loading">Loading&#8230;</div>
         ) : null}
        <ToastContainer autoClose={2000} />
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Client Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">
          <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteChild}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />

            <Row>
              <Col sm='2' className="pe-0">
                <ClientSidebar id={this.props.match.params.id} clientId={this.props.match.params.clientId} clientDetail={clietDetail} isResponsive={isResponsive} />
              </Col>
              <Col sm='10' className="">
                <Row className="project-header">
                                        <Col sm='7'>
                                     <LineBreadcrumbs
                                      title={this.props.t("Clients")}
                                      breadcrumbItem={this.props.t(  " Dashboard")}
                                    />
                                    </Col>
                                    <Col sm="4" className="">
                                        <h2 className="">{this.props.t( clietDetail.firstName + " " + clietDetail.lastName)}</h2>
                                        </Col>
                                    </Row>

            <ClientProfileMenu isResponsive={isResponsive} />
            <Row>
             
              
              <Col xl="12">
              <Card className="border-full">
                <CardBody>
                <Formik
                       enableReinitialize={true}
                       initialValues={{
                         
                         clientId: this.props.match.params.id,
                         childName: (this.state && this.state.dateTitle) || "",
                         birthDay: (this.state && this.state.birthDay) || "",
       
                       }}
                       validationSchema={Yup.object().shape({
                         childName: Yup.string().required("This is Required"),
                         birthDay: Yup.string().required("This is Required"),
                       })}
     
                       onSubmit={this.handleChildSubmit}
                     >
                        {({ errors, touched, values, handleChange, setFieldValue }) => (

                          <Form
                            className="needs-validation"
                          >

{/* <h5 className="card-title">Add children</h5> */}
                     <Row>
                          <Col sm="3">
                          <FormGroup className="mb-3">
                            <Label htmlFor="childName">
                              {this.props.t("Child Name *")}
                            </Label>
                            <SafeField
                              name="childName"
                              onChange={handleChange}                            
                              type="text"
                              
                              className={
                                "form-control" +
                                (errors.childName && touched.childName
                                  ? " is-invalid"
                                  : "")
                              }
                             
                              id="childName"
                            />
                             <ErrorMessage
                              name="childName"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>

                          </Col>
                          <Col sm="3">
                   <FormGroup className="mb-3">
                       <Label htmlFor="petName">
                         {this.props.t("Pet Name ")}
                       </Label>
                       <SafeField
                         name="petName"
                         onChange={handleChange}                            
                         type="text"
                         
                         className={
                           "form-control" +
                           (errors.petName && touched.petName
                             ? " is-invalid"
                             : "")
                         }
                        
                         id="petName"
                       />
                        <ErrorMessage
                         name="petName"
                         component="div"
                         className="invalid-feedback"
                       />
                     </FormGroup>
                   </Col>     
                          <Col sm="3">
                          <FormGroup className="mb15">

                              <Label htmlFor="birthDay">
                                {this.props.t("Brith Day *")}
                              </Label>
                              <Flatpickr
                                className={
                                  "form-control" +
                                  (errors.birthDay && touched.birthDay
                                    ? " is-invalid"
                                    : "")
                                }
                                placeholder=""
                                
                                onChange={(value) => setFieldValue('birthDay', value[0])}
                                options={{
                                  altInput: true,
                                  altFormat: "F j, Y",
                                  dateFormat: "Y-m-d",
                                  maxDate:'today'
                                }}
                              />
                              <ErrorMessage
                                name="birthDay"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>

                          </Col>

                         
                          <Col sm="2">
                           {isResponsive ? (
                               <button type="submit" className="btn btn-primary mb-3">Save</button>
                           ):(
                               <button type="submit" className="btn btn-primary mt-27"><i className=" bx bx-plus-medical"></i></button>
                           )}       
                         

                          </Col>
                    </Row>           
                    <Row>
                    <Col sm="12">
                    <h5 className="card-title">Childs</h5>
					<div className="table-responsive">
          <table className="table table-bordered border-primary">
              <thead className="">
							  <tr>
								<th style={{width:"10%"}}>#</th>
								<th style={{width:"80%"}}>Name</th>
								<th style={{width:"80%"}}>BirthDay</th>            
								<th style={{width:"10%"}}>Action</th>
							  </tr>
							</thead>
							<tbody>
              {map(childs, (child, childkey) => (
							  <tr key={"_note_" + childkey}>
								<td>{ childkey + 1 }</td>
								<td> {child.childName} </td>
                <td> <Moment format="D MMM YY">{child.birthDay}</Moment> </td>
               
								
								<td><Link to="#" onClick={() => this.onClickDelete(child)}  className="btn-del"><i className="bx bxs-trash"></i></Link></td>
							  </tr>
              ))} 
							</tbody>
						  </table>
						</div>
                    </Col>
                   </Row>
                            </Form>

                        )}
                        </Formik>
                </CardBody>
              </Card>
            
                
            </Col>
            
            </Row>
            </Col>
            </Row>
           
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
ClientFaimilyProfile.propTypes = {
  t: PropTypes.any,
  history:PropTypes.object,
  match: PropTypes.object,
  onGetClientDetail:PropTypes.func,
  clietDetail: PropTypes.object,
  addClientChild:PropTypes.func,
  onGetClientChild:PropTypes.func,
  childs:PropTypes.array,
  onDeleteChild:PropTypes.func,
  loading:PropTypes.object,
  isResponsive:PropTypes.object
  
}
const mapStateToProps = ({ Clients }) => (
  {
    loading: Clients.loading,
    clietDetail: Clients.clietDetail,
    childs:Clients.childs
    

  })
const mapDispatchToProps = dispatch => ({
  onGetClientDetail: clientId => dispatch(getClientDetail(clientId)),
  addClientChild:(data) => dispatch(addClientChild(data)),
  onGetClientChild: clientId => dispatch(getClientChild(clientId)),
  onDeleteChild : id => dispatch(deleteClientChild(id)),
  onUpdateClientProfile: (data) => dispatch(updateClientProfile(data))

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ClientFaimilyProfile))
